export var ENV_KEY = "ENV";
export var PUB_SUB = "PUB_SUB";
var Container = /** @class */ (function () {
    function Container() {
        var _this = this;
        Object.defineProperty(this, "injected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "inject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (key, value) {
                _this.injected[key] = value;
            }
        });
        Object.defineProperty(this, "resolve", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (key) {
                return _this.injected[key];
            }
        });
    }
    return Container;
}());
export { Container };
export var container = new Container();
